import {
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import React, { useMemo } from "react";

const AboutUsFourthTabCMSFormFields = ({
  activeTab,
  selectedTab,
  isFetching,
  formData,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  addMultiValueRepeaterChange,
  removeMultiValueRepeaterChange,
  updateMultiValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="messages-heading"
            fieldName="messages-heading"
            placeholderText="Heading"
            inputValue={formData?.["messages-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Inner Tabs */}
          <RepeatableMultipleInputStackFilds
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Inner Tabs"
            fieldId="messages-inner-tabs"
            fieldKey="messages-inner-tabs"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            addMultiValueRepeaterChange={addMultiValueRepeaterChange}
            removeMultiValueRepeaterChange={removeMultiValueRepeaterChange}
            updateMultiValueRepeaterChange={updateMultiValueRepeaterChange}
            translateField={true}
            extraContainerClasses="mt-5"
            filedStructure={[
              "TEXT",
              "TEXT",
              "TEXT_AREA",
              "TEXT_EDITOR",
              "TEXT",
              "TEXT",
              "IMAGE",
            ]}
            dataStructure={{
              tabName: "",
              tabValue: "",
              tabMessageTitle: "",
              tabMessageContent: "",
              tabPersonName: "",
              tabPersonDesignation: "",
              tabContentImageId: "",
            }}
            placeholderTexts={[
              "Tab Name",
              "Tab Value",
              "Tab Message Title",
              "Tab Message Content",
              "Tab Person Name",
              "Tab Person Designation",
              "",
            ]}
            hideStatus={[
              true,
              isHideInOtherLanguages,
              true,
              true,
              true,
              true,
              isHideInOtherLanguages,
            ]}
            colorGrade={colorGrade}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default AboutUsFourthTabCMSFormFields;
